import { fetcher } from '@commenda/utils';
import {
  CorporationJurisdictionSettings,
  CorporationSettings,
  EmailAliasUpdatePayload,
  EmailAliasUpdateResponse,
} from './types';

export async function updateCorporationSettings({
  corporationId,
  settings,
}: {
  corporationId: number;
  settings: CorporationSettings;
}) {
  const response = await fetcher(
    `new-sales-tax/corporations/${corporationId}/settings`,
    { method: 'POST', body: settings },
    undefined
  );

  return response;
}

export async function updateCorporationJurisdictionSettings({
  corporationId,
  jurisdictionId,
  settings,
}: {
  corporationId: number;
  jurisdictionId: string;
  settings: CorporationJurisdictionSettings;
}) {
  const response = await fetcher(
    `new-sales-tax/corporation-filing-setting/${corporationId}/settings/${jurisdictionId}`,
    { method: 'POST', body: settings },
    undefined
  );

  return response;
}

export async function updateEmailAliasForEmailForwarding({
  corporationId,
  payload,
}: {
  corporationId: number;
  payload: EmailAliasUpdatePayload;
}): Promise<EmailAliasUpdateResponse> {
  const response = await fetcher(
    `new-sales-tax/corporations/${corporationId}/email-alias`,
    { method: 'POST', body: payload },
    undefined
  );
  return response.json();
}
